module.exports = __webpack_public_path__ + "img/arabic-logo.64966acd.jpg";